import Vue from 'vue'

import resourceTranslations from './resource-translations'

Vue.mixin(resourceTranslations)
